import React from 'react'
import { usePartner } from '@@partner:helpers/hooks/auth'

import { generatePath, NavLink } from 'react-router-dom'
import { Nav, Navbar } from 'rsuite'
import { AddOutline } from 'react-ionicons'

import CatalogTopMenu from '@components/catalog/CatalogTopMenu'
import ProductGroupGrid from '@components/catalog/productGroup/ProductGroupGrid'

import {
  ROUTE_PRODUCT_GROUPS_ADD
} from '@@partner:config/routes'

export default function CatalogProductGroupsPage () {
  const { brandSlug } = usePartner()

  return (
    <div className="CatalogCategoriesPage">
      <h1 className="u-heading">Группы товаров</h1>
      <CatalogTopMenu />
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<AddOutline />}
            as={NavLink}
            to={generatePath(ROUTE_PRODUCT_GROUPS_ADD, {
              brandSlug
            })}
          >
             Добавить группу
          </Nav.Item>
        </Nav>
      </Navbar>
      <ProductGroupGrid brandSlug={brandSlug} />
    </div>
  )
}
